// A simple tool for parsing timeOffset values from VMAP files

const validOffsetFormats = {
	time: /[0-9]{2}:[0-9]{2}:[0-9]{2}(\.[0-9]{3})?/,
	// percentage
	percentage: /(100%)|([0-9]{0,2}(\.[0-9]+)?%)/,
	// start/end
	text: /(start)|(end)/,
	// position
	position: /#[0-9]+/
};

function parseFormatTime(timeString)
{
	return {
		format: "time",
		offset: new Date("1970-01-01T" + timeString + "Z").getTime() / 1000
	};
}

function parseFormatPercentage(timeString, duration)
{
	if (!duration)
	{
		return null;
	}

	const percentage = parseInt(timeString, 10) / 100;
	return {
		format: "percentage",
		offset: percentage === 1 ? Infinity : duration * percentage
	};
}

function parseFormatText(timeString)
{
	return {
		format: "text",
		offset: timeString === "start" ? 0 : Infinity
	};
}

function parseFormatPosition(timeString)
{
	return {
		format: "position",
		// Remove "#"
		offset: timeString.substring(1)
	};
}

function getRoll(time)
{
	if (time.format === "position")
		// "Positional" ads are ads kept in reserve to play whenever an
		// opportunity arises. This only applies to mid-rolls
		return "midroll";

	if (time.offset === 0)
		return "preroll";

	if (time.offset === Infinity)
		return "postroll";

	return "midroll";
}

function parseTime(timeString, duration)
{
	if (timeString === null)
	{
		// Some VolarAdBreaks don't have a timeOffset. These are mid-rolls
		// If other mid-rolls exist with positions, we should play them before
		// we play these non-descript mid-rolls
		return {
			format: "position",
			offset: Infinity,
			roll: "midroll"
		};
	}

	let format = null;

	for (const key in validOffsetFormats)
	{
		if (Object.prototype.hasOwnProperty.call(validOffsetFormats, key))
		{
			if (validOffsetFormats[key].test(timeString))
			{
				format = key;
				break;
			}
		}
	}

	let time = null;

	switch (format)
	{
	case "time":
		time = parseFormatTime(timeString);
		break;
	case "percentage":
		time = parseFormatPercentage(timeString, duration);
		break;
	case "text":
		time = parseFormatText(timeString);
		break;
	case "position":
		time = parseFormatPosition(timeString);
		break;
	default:
		return null;
	}

	time.roll = getRoll(time);

	return time;
}

module.exports = parseTime;
